// Import Libraries
import React, { Component } from 'react';
// Import JS Modules
import { builderDispatch } from '../../../_utils/ui';
import { UpdatePhotoEvents } from '../../common/events/event-declarations';
// Import JSX Modules
import PandaViewSimplePreviews from '../../common/panda-view-simple-previews';

class ListViewItemPreviewAndControls extends Component {
  static isEditEnabled(photo) {
    const { quantity, uploaded, fromBasket } = photo;

    return !!quantity && (!!fromBasket || !!uploaded);
  }

  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleRemoveByRootId = this.handleRemoveByRootId.bind(this);
  }

  handleEdit() {
    const {
      photo: {
        root_image_id: rootImageId,
        size: { key },
      },
      isLastPhoto,
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.ADVANCED_EDIT,
      imageId: rootImageId,
      sizeKey: key,
      isLastPhoto,
    });
  }

  handleRemove() {
    const {
      photo: {
        image_id: imageId,
        size: { key },
      },
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.REMOVE,
      sizeKey: key,
      imageId,
    });
  }

  handleRemoveByRootId() {
    const {
      photo: { root_image_id: rootImageId },
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.SHOW_REMOVE_CONFIRMATION,
      imageId: rootImageId,
      useRoot: true,
    });
  }

  render() {
    const {
      photo,
      displayRootImageOnly,
      isLastPhoto,
      showSize,
      showQuantity,
      showLowQualityWarning,
      recommendedPrintSize,
    } = this.props;

    const {
      size: { title: size, area },
      filename,
    } = photo;

    const handleEdit = displayRootImageOnly ? undefined : this.handleEdit;
    const handleRemove =
      displayRootImageOnly || isLastPhoto
        ? this.handleRemoveByRootId
        : this.handleRemove;

    return (
      <div className="d-inline-block list-item__preview">
        <PandaViewSimplePreviews
          {...photo}
          isWallet={size === 'Wallet'}
          size_area={area}
          recommendedPrintSize={recommendedPrintSize}
          showSize={showSize}
          showQuantity={showQuantity}
          showLowQualityWarning={showLowQualityWarning}
          lowQualityInformationPosition={showLowQualityWarning && 'right'}
          lowQualityInformationCSSClasses={showLowQualityWarning && 'desktop'}
          onClick={handleEdit}
        />

        <div
          role="toolbar"
          className="list-item__controls d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn btn-link btn-underline edit-photo"
            disabled={!this.constructor.isEditEnabled(photo)}
            aria-label={`Edit ${filename} ${size}`}
            title={`Edit ${filename} ${size}`}
            role="link"
            onClick={handleEdit}>
            Edit
          </button>
          <button
            type="button"
            className="btn btn-link remove-photo"
            aria-label={`Delete ${filename} ${size}`}
            title={`Delete ${filename} ${size}`}
            onClick={handleRemove}>
            <i className="far fa-trash-alt" />
          </button>
        </div>
      </div>
    );
  }
}

export default ListViewItemPreviewAndControls;
